export default "__VITE_ASSET__V_Ol1mWM__"